import { render } from "./FollowersList.vue?vue&type=template&id=bc59a11c&scoped=true"
import script from "./FollowersList.vue?vue&type=script&lang=js"
export * from "./FollowersList.vue?vue&type=script&lang=js"

import "./FollowersList.vue?vue&type=style&index=0&id=bc59a11c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc59a11c"]])

export default __exports__